import Request from '@/services/util/request-service';
import LocalStorageService from '@/services/storage/general/local-storage-service';

const UserGroupStorageService = {
  getMyGroupsCookie(): MyGroupsCookie {
    return LocalStorageService.get('USR_GRP') as MyGroupsCookie;
  },
  setMyGroupsCookie(data: MyGroupsCookie): void {
    LocalStorageService.set('USR_GRP', data);
  },
  deleteMyGroupsCookie(): void {
    LocalStorageService.delete('USR_GRP');
  },
  async initializeGroupsCookie(): Promise<MyGroupsCookie> {
    const groupResponse = await (await Request.get('user/getUsergroupList'))?.json();
    if (!groupResponse || groupResponse.error || !groupResponse.groups) {
      throw Error('Fetch request failed.');
    }

    this.setMyGroupsCookie({ groups: groupResponse.groups });
    return { groups: groupResponse.groups };
  },
};

export default UserGroupStorageService;
